export default class Config {
    static rightPoints = 100;
    static numQuestions = 10;
}
